import React from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import moment from "moment";

import { cleanDateFormat } from "utils/cleanDateFormat";
import { media } from "utils/style";
import { replaceHashValues } from "utils/replaceHashValues";

import Modal from "common-components/Modal/Modal";

function formatDate(date) {
  return moment(date)
    .format("MMM DD, YYYY")
    .toString();
}

const PendingDelete = ({ modalContent, dateOfRequest, ...props }) => (
  <Modal contentLabel="pending delete modal">
    <Container>
      <H2>{modalContent.section_title}</H2>
      <Div>
        {convertStringToElements(
          replaceHashValues(modalContent.section_description, {
            requesteddate: formatDate(cleanDateFormat(dateOfRequest))
          })
        )}
      </Div>
    </Container>
  </Modal>
);

export default PendingDelete;

const Container = styled.div`
  max-width: 361px;
  padding-right: 70px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const Div = styled.div`
  p {
    padding: 10px 0;
  }
`;

const H2 = styled.h2`
  margin-bottom: 10px;
`;
